import React, { FC, memo } from 'react';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { RentOptionCard } from './RentOptionCard';

interface RentOptionsListProps {
  selectedWarehouseId: string | undefined;
}

export const RentOptionsList: FC<RentOptionsListProps> = memo((props) => {
  const { selectedWarehouseId } = props;

  const { data: rentOptions } = useGetRentOptionsQuery(
    { warehouseId: selectedWarehouseId, showAsPromotion: true },
    { skip: !selectedWarehouseId },
  );

  // Filter rent options that should be shown as promotions
  const promoRentOptions = rentOptions?.filter(({ showAsPromotion }) => showAsPromotion) || [];

  if (!promoRentOptions.length) {
    return null;
  }

  return (
    <div className="space-y-4">
      {promoRentOptions.map((rentOption) => (
        <RentOptionCard key={rentOption.rentOptionId} rentOption={rentOption} />
      ))}
    </div>
  );
});
